export const CONDITIONS = [
  { id: "norm", label: "Normal", mult: 1.00 },
  { id: "over", label: "Overgrown", mult: 1.35 },
  { id: "negl", label: "Neglected", mult: 1.65 },
];
